import { TSizes } from '@/components/new-terminal/Text';

export function iconSize(size: TSizes): number {
  switch (size) {
    case 'xs':
      return 14;
    case 'sm':
      return 16;
    case 'lg':
      return 32;
    case 'xl':
      return 40;
    case 'md':
    default:
      return 24;
  }
}
